/**
 * Created by jonas on 2020-09-17.
 */


import {StageLayer} from "@nolimit/slot-launcher/bin/StageLayer";
import {NineToFive} from "../NineToFive";

import {gsap} from "gsap";
import {NolimitApplication} from "@nolimit/slot-launcher/bin/NolimitApplication";
import {WinWays} from "../components/WinWays";
import {BasedCountUp} from "../components/BasedCountUp";
import {NineToFiveGameAssets} from "../NineToFiveGameAssets";


// a step in the right direction but definetly not perfect, rewrite for next game
export class NineToFiveWinView extends PIXI.Container implements StageLayer {
    private basedCountUp:BasedCountUp;
    private basedWinWays:WinWays;
    private bigWinAnimation:PIXI.spine.Spine;
    private blackOut:PIXI.Sprite;
    private isBigWin:boolean;

    constructor() {
        super();
        this.name = "NineToFiveWinView";
        this.init();
    }

    private init() {
        this.blackOut = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.blackOut.name = "blackOut";
        this.blackOut.tint = PIXI.utils.string2hex("#0000CC");
        this.blackOut.position.set(360,360);
        this.blackOut.anchor.set(0.5,0.5);
        this.blackOut.alpha = 0;

        this.bigWinAnimation = new PIXI.spine.Spine(NineToFive.assetLoader.getSpineAsset(NineToFiveGameAssets.BIG_WIN_SPINE));
        this.bigWinAnimation.position.set(360, 386);

        this.basedCountUp = new BasedCountUp();
        this.basedCountUp.position.set(360, 300);
        this.basedWinWays = new WinWays();
        this.basedWinWays.position.set(360, 430);

        this.addChild(this.blackOut);
        this.addChild(this.bigWinAnimation);
        this.addChild(this.basedCountUp);
        this.addChild(this.basedWinWays);

        this.onResize();
    }

    // why is there no branch for when its not a big win
    private moveWinCountup() {
        if (this.isBigWin) {
            if (NolimitApplication.isLandscape) {
                this.basedCountUp.position.set(360, 570);
                this.basedWinWays.position.set(360, 700);
            } else {
                this.basedCountUp.position.set(360, 700);
                this.basedWinWays.position.set(360, 830);
            }
        }
    }

    public onResize() {
        this.blackOut.width = NolimitApplication.screenBounds.width;
        this.blackOut.height = NolimitApplication.screenBounds.height;
        this.moveWinCountup();
    }

    public winToggle(win:number, ways:number): gsap.core.Timeline {
       return gsap.timeline()
           .add(() => {
               this.basedCountUp.position.set(360, 300);
               this.basedWinWays.position.set(360, 430);
           })
           .add(this.basedCountUp.countUpInstant(win, 0))
           .add(this.basedWinWays.show(ways), '<')
           .add(this.basedCountUp.hide(), '>1')
           .add(this.basedWinWays.hide(), '<');
    }

    public clear(): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.basedCountUp.position.set(360, 300);
                this.basedWinWays.position.set(360, 430);
                this.basedCountUp.hide();
                this.basedWinWays.hide();
            })
    }

    public showAfterMaxWin(win:number):gsap.core.Timeline {
       return gsap.timeline().add(this.basedCountUp.showNoFade(win));
    }

    public countUpWin(to:number, from:number = 0, duration = 1, ways = NineToFive.model.totalWays):gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.basedCountUp.position.set(360, 300);
                this.basedWinWays.position.set(360, 430);
            })
            .add(duration > 0
                 ? this.basedCountUp.countUp(to, from, duration)
                 : this.basedCountUp.countUpInstant(to, from))
            .add(this.basedWinWays.show(ways))
            .add(this.basedCountUp.hide(), '>1')
            .add(this.basedWinWays.hide(), '<');
    }

    // split into smaller functions instead of these boolean arguments
    public bigWin(to:number, from:number, level:number, isFirst:boolean = false, isLast:boolean = false):gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.bigWinAnimation.state.setAnimation(0, `BW_${level}_Loop`, true);
                if (isFirst) {
                    this.isBigWin = true;
                }
                this.moveWinCountup();
            })
            .add(isFirst ? gsap.to(this.blackOut, {alpha: 0.7, duration:0.1}) : () => {}, '<')
            .add(isFirst ? gsap.to(this.bigWinAnimation, {alpha: 1, duration:0.1}) : () => {}, '<')
            .add(isFirst ? this.basedCountUp.countUp(to, from, 5.647) : this.basedCountUp.countUpNoFade(to, from, 5.647), '<')
            .add(isLast ? gsap.to(this.basedCountUp.position, {y: 300, duration: 0.7}) : () => {})
            .add(isLast ? gsap.to(this.basedWinWays.position, {y: 430, duration: 0.7}) : () => {}, '<')
            .add(isLast ? this.basedWinWays.show(NineToFive.model.totalWays) : () => {})
            .add(isLast ? this.basedCountUp.hide() : () => {}, isLast ? '>1.2' : '>')
            .add(isLast ? this.basedWinWays.hide() : () => {}, '<')
            .add(isLast ? gsap.to(this.bigWinAnimation, {alpha: 0, duration:0.1}) : () => {}, '<')
            .add(isLast ? gsap.to(this.blackOut, {alpha: 0, duration:0.1}) : () => {}, '<')
            .add(() => {
                this.bigWinAnimation.state.setEmptyAnimation(0, 0)
                if (isLast) {
                    this.isBigWin = false;
                }
            });
    }
}